<template>
    <div><!-- .wrap 제거. vue에서 스크롤 이벤트가 안잡힘. -->
        <div :id="tplSkinId" class="tpl-wrap con-wrap">
            <MysohoSpecialHeader/>
            <MysohoHeader/>
            <MysohoContent/>
            <MysohoFooter/>
        </div><!-- .con-wrap -->
        <MysohoFloatingBanner/>
    </div>
</template>

<script>
import '@/components/_load_componets_mobile.js'
export default {
    name : 'MainMobile'
    , data () {
        return {
            tplSkinId : `tpl-${this.getSkin()}`
        }
    }
}
</script>
